// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../../styles/variables.css\"","default":"#868686","primary":"#56CCF2","primaryLight":"#ABEAFF","button":"_2sNJ2zkdXBOkokS25gN8rL","disabled":"_3YcGZB8edcKTq1QW2NVXLB","buttonIcon":"_18vPwojX9tlDMTK29aO9Ch","prev":"_11Pr9ucC5ckzzEui0HNs1"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Module/components/NavButton.mod.css
// module id = 1648
// module chunks = 0